import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reviewact',
  templateUrl: './reviewact.component.html',
  styleUrls: ['./reviewact.component.scss']
})
export class ReviewactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
